<template>
    <ds-status
        emphasis="high"
        :type="$options.SMS_BROADCAST_STATUS_MESSAGE_TYPE[`${status}`]"
    >
        {{ $options.SMS_BROADCAST_STATUS_INDICATOR_MESSAGE[`${status}`] }}
    </ds-status>
</template>

<script>
import { SMS_BROADCAST_STATUS_INDICATOR_MESSAGE, SMS_BROADCAST_STATUS_MESSAGE_TYPE } from '../constants/smsBroadcast.constants';

export default {

    SMS_BROADCAST_STATUS_INDICATOR_MESSAGE,
    SMS_BROADCAST_STATUS_MESSAGE_TYPE,

    props: {
        status: {
            type: String,
        },
    },
};
</script>
